const VerificationStates = {
    /// <summary>
    /// Документы отсутствуют
    /// </summary>
    Empty:  0,
    /// <summary>
    /// Нужна проверка
    /// </summary>
    NeedToCheck: 1,
    /// <summary>
    /// Проверены
    /// </summary>
    Verified: 2,
    Cancelled: 3
};
const ReportTypes = {
    Disabled: 0,
    Manual: 1,
    QrCode: 2
};

const ReportPhotoTypes = {
    General: 0,
    Check: 1,
    QrCode: 2,
    File: 3
};

const OrderStatuses = {
    New: 1,
    InPocess: 2,
    Cancelled: 3,
    Complete: 4,
    Received: 5,
    ReadyToComplete: 6,
    GifteryRequested: 7,
    GifteryDelayed: 8,
    OrdersMonitoringTry: 101
};

const RewardTypes = {
    ElectronicGiftCard: 1,
    PrepaidBankCard: 2,
    PhysicalBankCard: 3,
    PhysicalPrize: 4
};

const BonusStrategyAccrualTypes = {
    //Процент от суммы
    SumPercent: 1,

    //Умножить на сумму
    SumMultiplication: 2
};

const RegisterTradePointTypes = {
    //Ввод текста
    Text: 0,

    //Выбор из адрески
    Select: 1
};

const ClaimEnums =
{
    'newsCreate': 1,
    'materialCreate': 3,
    'reportAdd': 5,
    'reportCheck': 6,
    'bonusSpend': 7,
    'skuCreate': 8,
    'ttAccess': 9,
    'ratingExport': 10,
    'faqEdit': 11,
    'motivationEdit': 12,
    'rewardsEdit': 13,
    'ratingSwitcher': 14,
    'skuLinkExport': 15,
    'tasksController': 16,
    'tasksEdit': 17,
    'newRepliesNotification': 18,

    'mainPageSettings': 20,
    'projectPage': 21,
    'newsPage': 22,
    'materialsPage': 23,
    'reportsPage': 24,
    'ratingPage': 25,
    'spendBonusesPage': 26,
    'analyticsPage': 27,
    'sellersPage': 28,
    'skuPage': 29,
    'motivationPage': 30,
    'faqPage': 31,
    'ordersPage': 32,
    'senderPage': 33,
    'tasksPage': 34,
    'feedbackPage': 35,
    'myProgressPage': 36
};

const TaskTypes = {
    Cumulative: 1,
    Simple: 2
};

const FieldTypes = {
    Single: 1,
    Table: 2
};

const PurposeType = {
    Count: 1,
    Summ: 2
};

const ScoringAccrualTypes = {
    Fixed: 1,
    SumPercent: 2,
    DependingOnSku: 3
};

const ScoringBurningTime = {
    Eternal: 1,
    InDays: 2,
    OnDate: 3
};

const MemberFilters = {
    Users: 1,
    TradePoints: 2,
    Roles: 3
};

const ScoringActivation = {
    OnDay: 1,
    InDays: 2,
    MonthInDay: 3,
    CumulativeForPeriod: 4
};

const Countries = {
    RUSSIA: 1,
    BELARUS: 2,
    KAZAKHSTAN: 3
};

const CurrencyDetails = {
    [Countries.RUSSIA]: { symbol: '₽', name: 'рублей', commissionText: 'Сумма в рублях с учетом комиссии:' },
    [Countries.BELARUS]: { symbol: 'Br', name: 'белорусских рублей', commissionText: 'Сумма в белорусских рублях с учетом комиссии:' },
    [Countries.KAZAKHSTAN]: { symbol: '₸', name: 'тенге', commissionText: 'Сумма в тенге с учетом комиссии:' }
};

const TaskAnswerStates = {
    /// Ждет проверки
    WaitingVerification: 1,
    /// принято
    Accepted: 2,
    /// доработано
    Finalized: 3,
    /// на доработке
    OnEdition: 4,
    /// отклонено
    Rejected: 5,
    /// удалить
    Remove: 10
};

const ScoringAccrualType = {
    FACT: 1,
    PERCENT: 2,
    PER_SKU: 3,
};

const UserLevelCode = {
    Bronze: 1,
    Silver: 2,
    Gold: 3,
    Platina: 4,
    GradeB: 5,
    GradeA: 6,
    GradeS: 7
};

const ProjectIds = {
  dev: {
    Froneri: 1,
    Project2: 2,
    KrasniyOktyabr: 4,
    Rusklimat: 5,
    ASBIS: 6,
    ASBIS_TSMir: 7,
    ASBIS_Mvideo: 2, // В dev нет
    Demo: 2,         // В dev нет
    A1: 2,           // В dev нет
    Ariston: 2,      // В dev нет
    Greenworks: 2,   // В dev нет
    Bonduelle: 2,    // В dev нет
    KIVI_1: 2,       // В dev нет
    KIVI_2: 2,       // В dev нет
    Veres: 2,        // В dev нет
    TestProject: 2,  // В dev нет
    Denvue: 2,       // В dev нет
    Rusproduct: 2,   // В dev нет
    Denvue_MCL: 2,   // В dev нет
    Test: 2,         // В dev нет
    MHI: 2,          // В dev нет
    Yarmarka: 2,     // В dev нет
    Marka1: 2,       // В dev нет
    WORX_Kress: 2,   // В dev нет
    General: 2,      // В dev нет
    Knauf: 10,
    Opus: 2,         // В dev нет
    Einhell: 2,      // В dev нет
    Cersanit: 2,     // В dev нет
    DIYProgram: 2,   // В dev нет
    AYA: 2,          // В dev нет
    Cersanit_RB: 2,  // В dev нет
    Cersanit_RK: 2,  // В dev нет
    ProjectTest: 2,  // В dev нет
    Froneri_Prod: 2, // В dev нет
    Jeelex: 2,       // В dev нет
    PROD_Project: 2,  // В dev нет
    Daccord: 39,
  },
  prod: {
    Froneri: 1,
    Project2: 2,
    KrasniyOktyabr: 4,
    Rusklimat: 5,
    ASBIS: 6,
    ASBIS_TSMir: 7,
    ASBIS_Mvideo: 8,
    Demo: 9,
    A1: 10,
    Ariston: 11,
    Greenworks: 12,
    Bonduelle: 13,
    KIVI_1: 14,
    KIVI_2: 15,
    Veres: 16,
    TestProject: 17,
    Denvue: 18,
    Rusproduct: 19,
    Denvue_MCL: 20,
    Test: 21,
    MHI: 22,
    Yarmarka: 23,
    Marka1: 24,
    WORX_Kress: 25,
    General: 26,
    Knauf: 27,
    Opus: 28,
    Einhell: 29,
    Cersanit: 30,
    DIYProgram: 31,
    AYA: 32,
    Cersanit_RB: 33,
    Cersanit_RK: 34,
    ProjectTest: 35,
    Froneri_Prod: 36,
    Jeelex: 37,
    PROD_Project: 38,
    Daccord: 39
  }
};

export {
    ReportTypes, ReportPhotoTypes, OrderStatuses, RewardTypes, ClaimEnums, BonusStrategyAccrualTypes, RegisterTradePointTypes,
    VerificationStates, TaskTypes, FieldTypes, PurposeType, ScoringAccrualTypes, ScoringBurningTime, MemberFilters, ScoringActivation, CurrencyDetails, TaskAnswerStates, ScoringAccrualType, UserLevelCode, ProjectIds
}




// WEBPACK FOOTER //
// ./Content/src/enums.js